import React, { useEffect } from "react";
import "./Home.css";
import ArtistCard from "../components/Artist-card";
import { useRef } from "react";
import { useState } from "react";
import lineSeparator from "../assets/img/line-sep.png";
import logoArtist1 from "../assets/img/artists/henri-maillot.png";
import logoArtist2 from "../assets/img/artists/luko.png";
import logoArtist3 from "../assets/img/artists/la-brebixx.png";
import logoArtist4 from "../assets/img/artists/julie-bernard.png";
import logoArtist5 from "../assets/img/artists/masami.png";
import logoArtist6 from "../assets/img/artists/rung-tsu-chang.png";
import Footer from "../components/Footer";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";

const HomeContent = () => {	

	const artistContainerRef = useRef(null) 
	const dotsContainerRef = useRef(null)
	const [show, setShow] = useState(false)
	const [currentArtist, setCurrentArtist] = useState({})

	const artists = [
		{
			id: 0,
			video: "_IA_rfCqv2w",
			titre: "Henri Maillot",
			description: "<p>Né à Saint-Denis de La Réunion, Henri Maillot se forme à l'école des Beaux-Arts de Paris et à l'Ecole Nationale Supérieure de Dessin et d'Arts Plastiques Claude Bernard. Il obtient le CAPES et se consacre quelques années à l'enseignement. Puis il se met en disponibilité pour finalement démissionner de l'Education Nationale et se consacrer à la création.</p><p>Le travail d'Henri Maillot se dirige rapidement et pour longtemps vers des pratiques d'art public. Si l'artiste touche à plusieurs pratiques (dessin, peinture, gravure), il n'en reste pas moins que la sculpture domine dans sa production. Elle se caractérise, sur le plan technique, par la précarité, la dérision avec des thématiques variées: le voyage, l'Histoire, les paysages, les légendeset les héros qui peuplent l'imaginaire de l'île.</p>",		
		},
		{
			id: 1,
			video: "igisNK-jMBY",
			titre: "Luko",
			description: "<p>Né en Corrèze, Luko connaît une migration dans l'Océan Indien lors de son enfance. Il repartira en Europe et en France pour réaliser ses études. Diplômé d'un BTS en arts appliqués et d'une licence d'art obtenu en Angleterre, il travaillera plusieurs années en tant que directeur artistique dans des agences événementielles.</p><p>À la lisière du Landart et au sortir du dessin, Luko s'inscrit dans un art écologique à travers des questionnements sur la durabilité de nos êtres et de nos territoires. Il tente une remise en question de la notion d'objet d'art en utilisant des matériaux périssables, dégradables. Il s'interroge aussi sur sa place dans un territoire : comment l'habiter ? Comment l'accompagner ?</p>",		
		},
		{
			id: 2,
			video: "0u2QCt55MhU",
			titre: "La Brebixx",
			description: "<p>Morgan Lecornu alias La Brebixx parcourt dès l'enfance les îles (Mayotte, Nouvelle Calédonie) mais aussi l'Australie et la Belgique. Il vit aujourd'hui à Sainte-Clotilde. Tout juste sorti des Beaux-Arts de La Réunion en 2020, il a obtenu le Prix Découverte du Dessin du festival Tropical Drawing en 2021.</p><p>La Brebixx a une pratique pluridisciplinaire. Il confronte son enfant intérieur à sa vie de jeune adulte. Son univers très coloré, se développe autour de la figuration libre, influencé par la peinture moderne et contemporaine. Sur ses oeuvres, il met en scène des formes naives qui se confrontent aux enjeux et défis de notre société (capitalisme, mondialisation, écologie...) et l'esprit de dualité (le réel/le fictif, le positif/négatif...) ainsi que la faune.</p>",		
		},
		{
			id: 3,
			video: "7X3gK-NwfOQ",
			titre: "Julie Bernard",
			description: "<p>Née à St-Leu, Julie Bernard grandit à La Réunion puis étudie les arts graphiques à Auguste Renoir à Paris et aux Beaux-arts de Bruxelles. Elle est diplômée en 2015 d'un Master Illustration et devient artiste-auteure. Elle collabore actuellement aux Editions Bayard, Zébulo et Rue du Monde. Ses projets sont primés par le Nami-Concours 2015 (Corée du S.), le CICLA 2018 (Chine) et le Prix Vanille 2019 (Réunion).</p><p>Ces illustrations se nourrissent en grande partie des petites poésies de l'ailleurs, du voyage et de l'insularité. Elles traduisent un attachement pour la couleur, les espaces flottants et la prédilection pour l'utopie et le rêve.</p>",		
		},
		{
			id: 4,
			video: "wfyv1qFer9Y",
			titre: "Masami",
			description: "<p>Née au Japon, Masami vient s'installer en 2012 à La Réunion, elle vit aujourd'hui à Trois-Bassins. Diplômée de l'Université d'Art et de Design de Joshibi de Tokyo, elle propose aujourd'hui des ateliers en sérigraphies, céramique, art japonais,...Elle participe régulièrement à des expositions aux quatre coins du monde (Nouvelle Zélande, Etats-Unis, Europe, etc.).</p><p>Née au Japon, Masami vient s'installer en 2012 à La Réunion, elle vit aujourd'hui à Trois-Bassins. Diplômée de l'Université d'Art et de Design de Joshibi de Tokyo, elle propose aujourd'hui des ateliers en sérigraphies, céramique, art japonais,...Elle participe régulièrement à des expositions aux quatre coins du monde (Nouvelle Zélande, Etats-Unis, Europe, etc.).</p>",		
		},
		{
			video: "iSkty0C5gPk",
			titre: "Rung Tsu Chang",
			description: "<p>Née à Taiwan, Rung Tsu Chang vit aujourd'hui à La Réunion. D'abord diplômée de l'École des arts et métiers Fu-Hsin et à l'Université de la Culture Chinoise, elle poursuit en 2009 une formation en Art-Thérapie. En 2010, elle arrive à Paris et entreprend l'apprentissage des techniques de gravure à l'Atelier 63 et à l'Atelier Contrepoint. Aujourd'hui installée à la Réunion, elle a remporté le Grand Prix Tropical Drawing 2021.</p><p>Expression de sa relation forte avec les espaces environnants, Rung Tsu Chang retranscrit sa propre architecture dans ses illustrations et ses gravures. Elle questionne la place de l'humais face à la nature, ainsi que les dimensions entre l'intime et l'infini.</p>",		
		}
	]

	const handleArtist = (index) => {

		if (!isMobile) {
			setCurrentArtist(artists[index]);
			if (currentArtist.id == index && !show) {			
				setShow(true)
				artistContainerRef.current?.scrollIntoView({behavior: 'smooth'});
			} else if (currentArtist.id == index && show) {		
				setShow(false)
				dotsContainerRef.current?.scrollIntoView({behavior: 'smooth'});
			} else {			
				setShow(false)
				setTimeout(() => {
					setShow(true)
					artistContainerRef.current?.scrollIntoView({behavior: 'smooth'});
				}, 300)			
			}			
		}
	
	}

	return (
		<Container fluid className="p-0">
			<Row id="dotsline" className="top-artists" ref={dotsContainerRef}>
				<Col xs={12} className="p-0 m-0">
					<span className="btn-floating pulse btn-artist btn-art1" onClick={() => handleArtist(0)}>
						<img src={logoArtist1} className="logo-artist" />
					</span>
					<span className="btn-floating pulse btn-artist btn-art2" onClick={() => handleArtist(1)}>
						<img src={logoArtist2} className="logo-artist" />
					</span>					
					<span className="btn-floating pulse btn-artist btn-art3" onClick={() => handleArtist(2)}>
						<img src={logoArtist3} className="logo-artist" />
					</span>
					<span className="btn-floating pulse btn-artist btn-art4" onClick={() => handleArtist(3)}>
						<img src={logoArtist4} className="logo-artist" />
					</span>
					<span className="btn-floating pulse btn-artist btn-art5" onClick={() => handleArtist(4)}>
						<img src={logoArtist5} className="logo-artist" />
					</span>
					<span className="btn-floating pulse btn-artist btn-art6" onClick={() => handleArtist(5)}>
						<img src={logoArtist6} className="logo-artist" />
					</span>
					<img src={lineSeparator} className="artists-line"/>					
				</Col>
			</Row>
		
			<span className="spacing-50" ref={artistContainerRef}></span>
			
			<div className="card-container" >			
				{show && currentArtist ? <ArtistCard video={currentArtist.video} titre={currentArtist.titre} description={currentArtist.description}  /> : ''}
			</div>
			<div className="card-container">
				<MobileCarousel artists={artists}/>
			</div>
			<span className="spacing-50"></span>

			<div className="row footer-header">
				<div className="col s12 no-gap">
					<img src={lineSeparator} className="footer-line"/>
				</div>							
			</div>

			<span className="spacing-50"></span>

			<div className="container">
				<h3 style={{'textAlign': 'center', 'textTransform': 'uppercase'}}>Projet</h3>
				<ProjectDescription/>
			</div>

			<Footer/>
		</Container>
	);
};

const MobileCarousel = ({artists}) => {

	const [index, setIndex] = useState(0)

	const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
		console.log(index);
  };

	if(isMobile) {
		return (
			<Carousel interval={null} indicators={false} activeIndex={index} onSelect={handleSelect}>
				{artists.map((artist, index) => {
					return (
						<Carousel.Item key={index}>								
								<ArtistCard video={artist.video} titre={artist.titre} description={artist.description}  />								
						</Carousel.Item>
					)
				})}						
			</Carousel>
		)
	}
}

const ProjectDescription = () => {
	return (
		<div style={{'textAlign': 'justify'}}> 
			<p>À travers de courtes vidéos présentant des portraits d'artistes, des visites d'ateliers et des évènements publics, La Vitrine souhaite oeuvrer à la visibilité et au rayonnement de la création réunionnaise à un niveau national et international, et ainsi se doter d'un outil supplémentaire pour accompagner les artistes dans leur parcours et favoriser des collaborations professionnelles.</p>
			<p>Îlien.ne.s, c'est une série de 6 documentaires courts (6 minutes) qui nous amène à la rencontre d'artistes de La Réunion, 3 femmes et 3 hommes.</p>
			<p>Ils sont filmés dans le cadre de leur travail, mais également dans leur intimité. En effet, nous les suivons dans leurs ateliers, chez eux, afin de comprendre ce qui les inspire, comment ils créent, etc. Ces documentaires souhaitent également interroger les rapports de ces artistes au territoire, ici l'île (Îlien.ne.s doit se comprendre comme la contraction entre île et alien, en anglais, étranger à un lieu).</p>
			<p>L'histoire du peuplement de La Réunion est liée à l'histoire de l'île, vieille d'à peine cinq siècles. Elle est née de la réunion d'individus de trois continents différents, venus de gré ou de force sur une île inhabitée, qui ont été forcés de cohabiter pour survivre, et se constituer en territoire.</p>
			<p>Cet héritage a-t-il fait naître une spécificité, voire une unicité, de la création réunionnaise ?</p>
			<p>Après avoir connu une longue imposition culturelle assimilationniste, comment les artistes réunionnais se sont réappropriés leur culture, quel(s) imaginaire(s) cela a-t-il fait naître ?</p>
			<p>Quel rôle joue la position îlienne, liée à la taille de l'île, à son isolement, à sa composition, sur la création artistique de La Réunion ? Du point de vue des représentations, l'île du continental (un ailleurs sous les tropiques) n'est pas la même que l'île de l'îlien (attachement, histoire, creuset culturel). Et enfin, la création insulaire peut elle être envisagée à la fois comme création d'insularité et comme insularité de la création ?</p>
	</div>
	)
}

const Home = () => {
	return <HomeContent />;
};


export default Home;
